var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkExpiredOrRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 107,
    viewBox: "0 0 127 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.1 54.9001C122.1 69.1001 116.3 81.9001 107 91.1001C97.9 100.2 85.2999 105.7 71.4 105.7C57.6 105.7 45 100.1 35.7999 91.1001C26.4999 81.9001 20.7 69.1001 20.7 54.9001C20.7 26.8001 43.4 4.1001 71.4 4.1001C99.3999 4.1001 122.1 26.9001 122.1 54.9001Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 21.5999C119.964 21.5999 121.8 19.7643 121.8 17.4999C121.8 15.2355 119.964 13.3999 117.7 13.3999C115.436 13.3999 113.6 15.2355 113.6 17.4999C113.6 19.7643 115.436 21.5999 117.7 21.5999Z",
    fill: "#F1F3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7 5.6C125.246 5.6 126.5 4.3464 126.5 2.8C126.5 1.2536 125.246 0 123.7 0C122.154 0 120.9 1.2536 120.9 2.8C120.9 4.3464 122.154 5.6 123.7 5.6Z",
    fill: "#F1F3F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 21.4999C23.8464 21.4999 25.1 20.2463 25.1 18.6999C25.1 17.1535 23.8464 15.8999 22.3 15.8999C20.7536 15.8999 19.5 17.1535 19.5 18.6999C19.5 20.2463 20.7536 21.4999 22.3 21.4999Z",
    fill: "#F1F3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 75.5001C8.07188 75.5001 10.4 73.172 10.4 70.3001C10.4 67.4282 8.07188 65.1001 5.2 65.1001C2.32812 65.1001 0 67.4282 0 70.3001C0 73.172 2.32812 75.5001 5.2 75.5001Z",
    fill: "#F1F3F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28.2998V91.0998C97.9 100.2 85.3 105.7 71.4001 105.7C57.6001 105.7 45 100.1 35.8 91.0998V28.2998H107Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5999 73.6001H53.2V78.2001H89.5999V73.6001Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5999 83.7002H53.2V88.3002H89.5999V83.7002Z",
    fill: "#D6DCE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7 93.8999H62.1V98.4999H80.7V93.8999Z",
    fill: "#D6DCE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4277 53.4532C81.2131 54.383 80.8913 55.277 80.4979 56.0994C79.4609 58.0305 77.9232 59.6039 75.9922 60.5694C73.9897 61.6064 71.6296 61.964 69.2337 61.4991C63.6552 60.3191 60.0435 54.8836 61.2235 49.2694C62.4036 43.6551 67.8033 40.0434 73.4175 41.2235C75.4201 41.6526 77.1723 42.6181 78.6384 44.0127C81.0701 46.5159 82.1071 50.0561 81.4277 53.4532Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8711 46.5464L68.8718 46.5556L68.8726 46.5647L69.4079 52.3453C69.4857 53.4422 70.4248 54.3026 71.5133 54.3026C72.6018 54.3026 73.5409 53.4422 73.6187 52.3453L74.154 46.5647L74.1549 46.5543L74.1557 46.5438C74.2685 44.9642 73.0597 43.6846 71.5133 43.6846C69.955 43.6846 68.7575 45.0126 68.8711 46.5464Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5133 54.1606C70.2458 54.1606 69.226 55.1805 69.226 56.448C69.226 57.7155 70.2458 58.7353 71.5133 58.7353C72.7808 58.7353 73.8006 57.7155 73.8006 56.448C73.8006 55.1805 72.7808 54.1606 71.5133 54.1606Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkExpiredOrRejected);
export default __webpack_public_path__ + "static/media/SparkExpiredOrRejected.fd3748c8e50f904c7c6c23487dfef886.svg";
export { ForwardRef as ReactComponent };